const getSlope = ({ x: [x1, x2], y: [y1, y2] }) => {
  const delta = (y2 - y1) / (x2 - x1)
  return delta
}
const getX = ({ y, m, b }) => {
  // y = mx + b
  const x = (y - b) / m
  return x
}

export { getSlope, getX }
